<template>
    <div>
        <base-logo class="main-logo logo-style"></base-logo>
        <page-loader
                v-if="showPageLoader"
        ></page-loader>
        <div class="login-panel auto-min-height">
            <div class="card card-auth with-shadow">
                <h2 class="auth-heading">
                    Login to your account
                    <span> Please enter your account credentials. </span>
                </h2>

                <div class="auth-body">
                    <b-form @submit.stop.prevent="onSubmit">
                        <b-form-group
                            id="login_username"
                            label="Email"
                            label-for="login-username-input"
                        >
                            <b-form-input
                                id="login_username"
                                v-model="formData.username"
                                v-validate="{ required: true, max: 50, min: 6 }"
                                placeholder="Enter your account email"
                                autocomplete="off"
                                data-vv-name="email"
                                :class="{
                                    'is-invalid': errors.has('email'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="login_password"
                            label="Password"
                            type="password"
                            label-for="login-password-input"
                        >
                            <b-form-input
                                id="login-password-input"
                                v-model="formData.password"
                                v-validate="{ required: true, max: 20, min: 6 }"
                                placeholder="Enter your account password"
                                autocomplete="off"
                                type="password"
                                data-vv-name="password"
                                :class="{
                                    'is-invalid': errors.has('password'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                        <Recaptcha v-if="useRecaptcha" :forceRerenderRecaptcha="forceRerenderRecaptcha" @onVerify="onVerify"/>
                        <router-link
                                to="users/forgot-password"
                                class="btn forgot-link btn-link float-right"
                        >Forgot your password?</router-link
                        >
                        <div class="">
                            <base-button style="width: 100%;"
                                    btn-label="Sign In"
                                    btn-type="submit"
                                    btn-variant="primary"
                                    :disabled="disabled"
                                    :class="disabled ? 'disabled' : ''"
                            ></base-button>
                        </div>
                        <div class="already-a-customer">
                            <p>
                                New Customer? <a href="/signup">Register Now</a>
                            </p>
                        </div>
                        <div  v-if="isUaePass=='true'" class="divider">
                            <span class="divider-text">OR</span>
                        </div>
                        <a  v-if="isUaePass=='true'" class="temp-btn" @click="redirect">
                            <img style="min-width: 100%" src="@/assets/images/UAEPASS_login.png" />
                            <!--Sign In with UAE PASS-->
                        </a>

                        <!-- <base-toast></base-toast> -->
                    </b-form>
                </div>
                <b-modal
            ref="otpmodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <otp-modal
                v-if="is_data_fetched"
                :data="otpData"
                heading="Two-Factor Authentication"
                @verificationStatus="otpResponse"
                @reSendOTP="reSendOTP"
            ></otp-modal>
        </b-modal>

                <uae-pass-popup
                 v-if="isUaePass=='true'"
                        title="UAE PASS - Idenfo Account Linking"
                        cancelText ="No"
                        :onCancel=redirectToSignUp
                        :onConfrim=stayOnLogin
                >
                </uae-pass-popup>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
import OtpModal from '@/components/popups/OTPModal.vue'
// import OtpModal from '@/components/registration/OtpModal.vue'
import request from '@/utils/request'
import axios from 'axios'
import BaseButton from "../../components/BaseButton";
const viewBrandingApi = new resource('configurations/branding')
import UaePassPopup from "../../components/popups/UaePassPopup";
import PageLoader from "../../components/PageLoader"
import Recaptcha from "@/components/registration/Recaptcha.vue"

// import { encrypt,decrypt } from '../../utils/functions';


export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {UaePassPopup, BaseButton, OtpModal, PageLoader, Recaptcha},
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            useRecaptcha: process.env.VUE_APP_LOGIN_RECAPTCHA == 'true',
            country:process.env.VUE_APP_COUNTRY_TEMP,
            isUaePass:process.env.VUE_APP_UAE_PASS,
            formData: this.initializeFormData(),
            forceRerenderRecaptcha: 0,
            recaptchaResponse: null,
            otpData: null,
            is_data_fetched: false,
            tempData:null,
            redirectURL:process.env.VUE_APP_API_URL+"users/uae-pass-callback",
            // redirectURL:"https://uaedirectuat.idenfo.com/api/users/uae-pass-callback",
            clientId:process.env.VUE_APP_UAE_PASS_ID,
            customMessage:""
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'user', 'success', 'hasScopes', 'redirectUrl','showPageLoader','uaePassObject']),
        disabled(){
            return this.loading || (this.useRecaptcha && !this.recaptchaResponse)  
        },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the user has been updated
         *
         * @return {void}
         */
        user(value) {
            // check if the value is not empty
            // and redirect to inner page
            if (value !== null && value !== undefined) {
                this.$store.commit('setDataSegmentId', value.dataSegmentIds[0])
                localStorage.setItem('dataSegmentId',value.dataSegmentIds[0])
                localStorage.setItem('activeDataSegmentId',value.dataSegmentIds[0])
                if (this.redirectUrl) {
                    this.$router.push({ path: this.redirectUrl })
                    this.$store.commit('setRedirectUrl', null)
                } else {
                    this.$router.push({ name: 'view-customer-profile' })
                }
            }
        }, // End of user()
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    async created() {

        // Change theme color
        await this.getBrandingData()
        if(this.$route.query)
        {
            if(this.$route.query.code)
            {
                this.$store.commit('showPageLoader', true)
                await this.uaePassLogin(this.$route.query.code)
            }
            else if(this.$route.query.error)
            {
                this.$store.commit('setError', this.$route.query.error)
            }
        }
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        onVerify(response){
            if(response) {
                this.recaptchaResponse = response
            }
        },
        stayOnLogin()
        {
            this.formData.uaePassDetails = this.uaePassObject
            // console.log('this form data-----',this.formData)
        },
        redirectToSignUp()
        {
           this.$router.push('/signup')
        },
        async uaePassLogin(code)
        {
            let param = "code="+code
            if(this.$route.query.token)
            {
                param="accessToken="+code
            }
            let data =  await axios.get(`${process.env.VUE_APP_API_URL}users/uae-pass-auth?${param}`)
                .then(function (response) {
                    return response
                })

                .catch(function (error) {
                    console.log('uae pass login error',error);
                });
            // console.log('--------response------',data)
            if(data && data.status==200)
            {
                if(data.data)
                {
                    // this.$store.commit('setLoading', false)

                    if(data.data.status)
                    {
                        let tmp = {
                            username:data.data.data.email,
                            password:"",
                            uaePassDetails:data.data.data,
                            isUaePassLogin:true
                        }
                        let encryptedForm=this.$encrypt(tmp)
                        localStorage.setItem('uaePassLogin',"true")
                        await this.$store.dispatch('authLogin', {
                            data: encryptedForm,
                        })
                        this.$store.commit('showPageLoader', false)
                    }
                    else
                    {
                        this.$store.commit('setUaePassObject',data.data.data)
                        this.customMessage = data.data.message
                        this.$bvModal.show('uae-pass-popup')
                        // console.log('store value',this.$store.getters.uaePassObject)
                        this.$store.commit('showPageLoader', false)
                    }
                }
            }
            else
            {
                this.$store.commit('setError', "Something went wrong")
                this.$store.commit('showPageLoader', false)
            }
        },
        redirect()
        {
            // let uaePassURL ="https://stg-id.uaepass.ae/idshub/authorize?redirect_uri="+this.redirectURL+"&client_id="+this.clientId+"&response_type=code&state=pd3PgezRwk596u2yfRwqOgru&scope=urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId&acr_values=urn:safelayer:tws:policies:authentication:level:low"
            let uaePassURL =process.env.VUE_APP_UAE_PASS_URL+"idshub/authorize?redirect_uri="+this.redirectURL+"&client_id="+this.clientId+"&response_type=code&state=login&scope=urn:uae:digitalid:profile:general urn:uae:digitalid:profile:general:profileType urn:uae:digitalid:profile:general:unifiedId&acr_values=urn:safelayer:tws:policies:authentication:level:low"
            // let uaePassURL = "http://localhost:6001/redirectTest"
            window.location.assign(uaePassURL)
        },
        initializeFormData() {
            return {
                username: '',
                password: '',
                uaePassDetails:'',
                loginAt: Date.now(),

            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()

            if (result) {
                try {
                    if(this.uaePassObject && (this.uaePassObject.uuid || this.uaePassObject.email))
                    {
                        localStorage.setItem('uaePassLogin',"true")
                        this.formData.uaePassDetails = this.uaePassObject
                    }
                    let encryptedForm = this.$encrypt({...this.formData, cToken: this.recaptchaResponse})
                    this.$store.commit('setLoading', true)
                    let resp =  await axios.post(`${process.env.VUE_APP_API_URL}users/login`, {
                        data:encryptedForm,
                    })
                   .then(function (response) {
                       return response
                    })
                   .catch(function (error) {
                       if (error.response) {
                           return {error : error.response.data.message};
                       } else if (error.request) {
                           return {error :'No response received from server'}
                           // return {error :'Your IP has been blocked, please contact Admin'}
                       } else {
                           // Something happened in setting up the request that triggered an Error
                           return {error :error.message};
                       }
                    });
                    this.forceRerenderRecaptcha = Math.random()*100

                    // console.log('response0------',resp)

                    // authLogin action in auth store
                    if(resp && resp.error)
                    {
                        this.$store.commit('setLoading', false)
                        this.$store.commit('setError', resp.error)
                        return
                    }
                    if(typeof (resp.data.data)=="string")
                    {
                        this.tempData=resp
                        this.tempData.data.data=this.$decrypt(this.tempData.data.data)
                    }


                    if(this.tempData){
                        if(this.tempData.data.data.twoFA)
                        {
                            await this.sendOPT(this.tempData.data.data)
                        }
                        else
                        {
                            await this.loginUser(this.tempData.data.data)
                        }

                    }
                    else{

                        this.$store.commit('setError', "Could not load data")
                        this.$store.commit('setLoading', false)


                    //     this.$store.commit('setUaePassObject',{})
                    // this.$analytics.fbq.event('loginClick')

                    }
                } catch (error) {
                    console.log(error, 'There is an error on login submit')
                    this.$store.commit('setError', "There is an error on login submit")
                    this.$store.commit('setLoading', false)

                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
                this.$store.commit('setLoading', false)
            }
        }, // End of onSubmit() method
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        }, // End of getBrandingData() method
        
        async sendOPT(value) {
            try {
                this.is_data_fetched=true
                if(this.uaePassObject && (this.uaePassObject.uuid || this.uaePassObject.email))
                {
                    localStorage.setItem('uaePassLogin',"true")
                    this.formData.uaePassDetails = this.uaePassObject
                }
                this.otpData=this.formData
                this.otpData.token=value.token
                this.otpData.url='/users/login'
                this.$refs.otpmodal.show()
                this.$store.commit('setLoading', false)
            } catch (error) {
                console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
        }, // End of sendOtp() method
        async reSendOTP() {
            this.$refs.otpmodal.hide()
            // await this.sendOPT(this.tempData.data.data)

        }, // End of reSendOTP() method

        async otpResponse(data) {
            // console.log('OTP result-----',data)
            if(data && data.data && data.data.data && typeof (data.data.data)=="string")
            {
                this.tempData=data.data.data
                data=this.$decrypt(data.data.data)
            }
            // console.log('OTP result decrypted-----',data)
            if(data.accessToken)
            {
                this.$refs.otpmodal.hide()
                await this.loginUser(data)
            }
            else
            {
                this.$store.commit('setError', data.error)
            }
            this.$store.commit('setLoading', false)

        }, // End of otpResponse() method

        async loginUser(data)
        {
            this.$store.commit('setSuccess', "Login Successfully")
            this.$store.commit('setToken', data.accessToken)
            this.$store.commit('setTokenExpiry',  data.expiresIn)
            this.$store.commit('setUser', data.profile)
            this.$store.commit('setLoading', false)
        }
    },
    // End of Component > mounted
} // End of export default
</script>
<style>
    .temp-btn
    {
        height: 70px;
        text-align: center;
        display: flex;
        width: 100%;
        /*background: white !important;*/
        /*color: purple !important;*/
        /*border: 1px solid purple !important;*/
        text-decoration: none !important;
        padding: 10px !important;
    }
    .divider {
        display: flex;
        align-items: center;
        text-align: center;
        margin: 20px 0;
    }

    .divider::before,
    .divider::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid #000;
    }

    .divider-text {
        padding: 0 10px;
    }

</style>